import { render } from "./arrangePeopleSelectDialog.vue?vue&type=template&id=61394d54&scoped=true"
import script from "./arrangePeopleSelectDialog.vue?vue&type=script&lang=js"
export * from "./arrangePeopleSelectDialog.vue?vue&type=script&lang=js"

import "./arrangePeopleSelectDialog.vue?vue&type=style&index=0&id=61394d54&lang=scss&scoped=true"

import exportComponent from "D:\\project\\admin-system3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-61394d54"]])

export default __exports__